import ObjectUtil from "utils/ObjectUtil";
import React from "react";
import {ValidationRuleNames} from "common/validation/rules/ValidationRule";
import {ValidationRuleBytesProps} from "common/validation/rules/ValidationRuleBytes";
import useUIValidator from "common/validation/component/UseUIValidator";
import classNames from "classnames";

export interface UITextAreaProps {
  value?: string;
  valueChanged?: (value: string) => void;
  autoFocus?: boolean;
  setFocus?: boolean;
  full?: boolean;
  className?: string;
  style?: React.CSSProperties;
  attrs?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
  rules?: Array<ValidationRuleNames>;
  bytes?: ValidationRuleBytesProps;
}

export default UITextArea;

function UITextArea(props: UITextAreaProps) {
  const [inputValue, setInputValue] = React.useState<string>(props.value == null ? "" : props.value);
  const style: React.CSSProperties = { ...props.style };
  const attrs: React.TextareaHTMLAttributes<HTMLTextAreaElement> = { ...props.attrs };
  const {required, valueChecker, errorClassName} = useUIValidator({rules: props.rules, bytes: props.bytes})

  React.useEffect(() => {
    valueChecker.setValue(inputValue);
  }, [inputValue]);

  React.useEffect(() => {
    setInputValue(props.value == null ? "" : props.value);
  }, [props.value]);

  React.useEffect(
    () => {
      if (props.valueChanged != null) {
        props.valueChanged(attrs?.disabled === true ? ObjectUtil.undefined : inputValue);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [attrs.disabled, inputValue]
  );

  style.boxSizing = ObjectUtil.defaultIfNull(style.boxSizing, "border-box");
  style.resize = ObjectUtil.defaultIfNull(style.resize, "vertical");

  if (props.full === true) {
    style.width = "100%";
  }

  return (
    <textarea
      ref={(element) => props.setFocus === true && element?.focus()}
      value={inputValue}
      className={classNames(props.className, errorClassName)}
      style={style}
      {...attrs}
      autoFocus={props.autoFocus === true}
      onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setInputValue(event.target.value);

        if (props.valueChanged != null) {
          props.valueChanged(event.target.value);
        }
      }}
      required={required}
      data-security={"off"}
      data-value-rule={props.rules}
      data-value-bytes={props.bytes}
      data-validation-message={valueChecker.message}
    />
  );
}
